import React from 'react';

const branchColors = {
  Gulberg: '#2dd4a0',
  'Adda Plot': '#4f8ef7'
};

export function ChannelBadge({ branch }) {
  const label = branch || '-';
  const background = branchColors[label] || '#555';
  return (
    <span className="channel-badge" style={{ background, color: '#fff' }}>
      {label}
    </span>
  );
}
